import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { DeviceStatus } from '../../../../constants/DeviceStatus';
import {
  VerticalProgress,
  PushButton,
} from '../../components';
import {
  Sound,
  Sounds,
} from '../../../Sound';
import { toNumber } from '../../../../utils/numbers';
import convertUnit from '../../../../utils/unit-converter';
import {
  IconUnitLabel,
  InventoryLabel,
  TargetLabel,
  BalanceLabel,
  DeviceStatusLabel,
} from '../../components/labels';
import {
  AnalogIconList,
  AnalogUnitList,
} from '../../../../constants/DeviceModels';
import {
  getRunMode,
  isRunModeNewYork,
} from '../../../../stores/batch/run-mode';
import MaterialVisibilityChange from '../../components/MaterialVisibilityChange';

@observer
class AggDecumScale extends Component {
  render() {
    const { device, batchStore, settingsStore, onClose, onOpen, materialStore, material, moisture, currentBalance, materialTypeClass, active, ports } = this.props;
    const { openPort, closePort, statusPort, openPortAdditional, closePortAdditional } = ports;
    const { configuration } = settingsStore;
    const runMode = getRunMode(configuration, batchStore);
    const md = material ? materialStore.materialDetails[material.materialDetailId] || {} : {};
    const name = material ? materialStore.getMaterialName(material) : device.description;
    const secondGateActive = active;
    const gateAnimation = active ? 'gate-open' : 'gate-close';
    const secondGateAnimation = secondGateActive ? 'second-gate-open' : 'second-gate-close';
    const deviceStatus = material ? batchStore.getDeviceStatus(`${device.id}-${material.code}`) : batchStore.getDeviceStatusDefault(device);
    const { status, target, unit, error, startWeight = 0, finishWeight = 0 } = deviceStatus;
    const isError = error ? 'error' : '';
    const weight = batchStore.getScaleWeight(device);
    const indicatorError = batchStore.isIndicatorValueError(weight) ? DeviceStatus.INDICATOR_ERROR : '';
    const materialAnimation = weight > 0 && active ? 'material-animation' : '';
    const secondGateMaterialAnimation = weight > 0 && secondGateActive ? 'second-gate-material-animation' : '';
    const inputDisabled = batchStore.isInputDisabled(statusPort) ? 'device-input-disabled' : '';
    const deviceUnit = batchStore.getUnitById(device.unitId);
    const batchUnit = unit || deviceUnit;
    const isDeferenceUnit = unit && target ? unit !== deviceUnit : false;
    const sWeight = startWeight;
    let convertedTarget = 0;
    let convertedWeight = 0;
    let convertedStartWeight = 0;
    const isDischargeMode = (
      [DeviceStatus.DISCHARGING, DeviceStatus.JOG, DeviceStatus.HOLD, DeviceStatus.SETTLING, DeviceStatus.OVER].includes(deviceStatus.status)
      && batchStore.running.length
    );

    if (isDeferenceUnit) {
      convertedTarget = toNumber(convertUnit(target, deviceUnit, batchUnit), 0);
      convertedWeight = finishWeight
        ? toNumber(convertUnit(finishWeight, deviceUnit, batchUnit), 0)
        : toNumber(convertUnit(weight, deviceUnit, batchUnit), 0);
      convertedStartWeight = toNumber(convertUnit(sWeight, deviceUnit, batchUnit), 0);
    }

    const w = finishWeight ? finishWeight : sWeight ? sWeight - weight : 0;
    const progress = w > 0 ? 100 - (((target - w) / target) * 100) : 0;
    const top = -65 + (progress*0.65);
    const otherMaterials = materialStore.getMaterialWithTheSamePosition(material);
    const holdFeedIcon = batchStore.isHoldFeedDevice(device.id) ? 'play' : 'pause';
    const isDoubleGate = batchStore.isDoubleGateScale(device);

    return (
      <div id={`device-${device.id}`} className={`${gateAnimation} ${secondGateAnimation} ${materialAnimation} ${secondGateMaterialAnimation} device-gui device-gui--agg-scale decum-scale device-${isError} ${inputDisabled}`}>
        <Sound file={Sounds.alarm} play={isError} loop={true}/>

        <MaterialVisibilityChange materials={otherMaterials}
          material={material}
          onMaterialClick={m => materialStore.switchMaterialVisibilityForDecumScale(m)}
        />

        <DeviceStatusLabel
          name={name}
          status={status}
          title={`#${device.id} ${inputDisabled}`}
          displayIcon={inputDisabled}
          isHorizontal={true}
        />

        <div className={`device-icon ${materialTypeClass}`} style={{top: top > 0 ? 0 : top + '%'}} />

        {!!moisture &&
          <IconUnitLabel value={moisture} unit={AnalogUnitList['%']} icon={AnalogIconList.DROP}/>
        }

        {md.showBalance &&
          <InventoryLabel balance={currentBalance} decimal={1} unit={md.itemInventoryUnitSymbol}/>
        }

        <div className="device-label-group">
          <div className="device-label device-label-target">
            <TargetLabel target={target} unit={deviceUnit} convertedTarget={convertedTarget} convertedUnit={batchUnit} padZeros={device.graduation > 1}/>
            <BalanceLabel balance={indicatorError || w} unit={deviceUnit} convertedBalance={convertedStartWeight ? convertedStartWeight - convertedWeight : 0} convertedUnit={batchUnit} padZeros={device.graduation > 1}/>
          </div>

          {(configuration.manualFeed || !batchStore.running.length) && (
            <div className="scale-buttons">
              {closePort && (
                <PushButton
                  className="btn-batch btn-batch-red"
                  port={closePort}
                  onPush={() => onClose(closePort, openPort)}
                >
                  <i className="fa fa-arrow-up"/>
                </PushButton>
              )}
              {openPort && (
                <PushButton
                  port={openPort}
                  onPush={() => onOpen(openPort, closePort)}
                >
                </PushButton>
              )}
            </div>
          )}

          {isDoubleGate && (
            <div className="scale-buttons-second-gate">
              {closePortAdditional && (
                <PushButton
                  className="btn-batch btn-batch-red"
                  port={closePortAdditional}
                  onPush={() => onClose(closePortAdditional, openPortAdditional)}
                >
                  <i className="fa fa-arrow-up"/>
                </PushButton>
              )}
              {openPortAdditional && (
                <PushButton
                  port={openPortAdditional}
                  onPush={() => onOpen(openPortAdditional, closePortAdditional)}
                >
                </PushButton>
              )}
            </div>
          )}
        </div>

        <div className="device-icon aggregate"/>
        <div className={`device-icon gate ${isDoubleGate ? 'first-gate' : ''}`}/>
        <div className={`device-icon particle ${isDoubleGate ? 'particle-first-gate' : ''}`}/>

        {isDoubleGate && (
          <React.Fragment>
            <div className={'device-icon gate second-gate'}/>
            <div className={'device-icon particle particle-second-gate'}/>
          </React.Fragment>
        )}

        {isDischargeMode && !batchStore.isHoldFeed && !isRunModeNewYork(runMode) && (
          <button className={'btn-on btn-batch btn-batch-red btn-hold-feed'}
            title={batchStore.isHoldFeedDevice(device.id) ? 'Start feed' : 'Hold feed'}
            onClick={(e) => {
              e.stopPropagation();
              batchStore.onPausePlayFeedButtonPress(device.id);
            }}>
            <i className={`fa fa-${holdFeedIcon}`}/>
          </button>
        )}

        <VerticalProgress
          showPercent={true}
          showProgress={true}
          value={progress}
          active={active}
        />
      </div>
    );
  }
}

export default AggDecumScale;
